import React, { useCallback } from 'react';

import Modal from '../../shared/modals/modal.component';
import { Client } from './types';
import { YesNoFlag } from '../../shared/types';

type DeleteModalProps = {
  entityToRemove: Client,
  hideModal: () => void,
  removeEntity: (entity: Client, options: { rowIndex: number }) => void,
  rowIndex: number,
  isVisible: boolean,
  isRemovingEntity: boolean,
}

const DeleteModal = ({
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingEntity,
}: DeleteModalProps) => {
  const removeClient = useCallback(() => {
    if (entityToRemove) {
      removeEntity({ ...entityToRemove }, { rowIndex });
    }
  }, [removeEntity, entityToRemove, rowIndex]);
  if (entityToRemove) {
    if (entityToRemove.enabledFlag === YesNoFlag.Y) {
      return (
        <Modal
          className="delete-client-modal"
          dismissText="Cancel"
          title="Delete Client"
          closeAction={hideModal}
          dismissAction={hideModal}
          isVisible={isVisible}
          isBusy={isRemovingEntity}
        >
          { entityToRemove
            ? (
              <div>
                Clients must be disabled before deleting.<br/>
                Client ID: {entityToRemove.clientId}<br/>
                Name: {entityToRemove.name}
              </div>
            )
            : null
          }
        </Modal>
      );
    } else {
      return (
        <Modal
          className="delete-client-modal"
          dismissText="Cancel"
          submitText="Yes"
          title="Delete Client"
          closeAction={hideModal}
          dismissAction={hideModal}
          submitAction={removeClient}
          isVisible={isVisible}
          isBusy={isRemovingEntity}
        >
          { entityToRemove
            ? (
              <div>
                Are you sure you want to delete:<br/><br/>
                Client ID: {entityToRemove.clientId}<br/>
                Name: {entityToRemove.name}
              </div>
            )
            : null
          }
        </Modal>
      );
    }
  } else {
    return (
      <Modal
        className="delete-client-modal"
        dismissText="Cancel"
        submitText="Yes"
        title="Delete Client"
        closeAction={hideModal}
        dismissAction={hideModal}
        submitAction={removeClient}
        isVisible={isVisible}
        isBusy={isRemovingEntity}
      >
        { entityToRemove
          ? (
            <div>
              Are you sure you want to delete?<br/><br/>
            </div>
          )
          : null
        }
      </Modal>
    );
  }
};

export default DeleteModal;
